import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map, of } from 'rxjs';
import { readAccountNavState } from '../services/saved-accounts/saved-accounts.model';

export const authGuard: CanActivateFn = route => {
  const router = inject(Router);

  // KD-4/R-1/R-7/C-14: skip the token check only when the current navigation to `/auth` was
  // dispatched imperatively by the chooser's cross-role pick or the switcher's «Додати акаунт»
  // (never a reload or Back/Forward, which Angular replays through the same `extras.state`).
  const nav = readAccountNavState(router);
  if (route.routeConfig?.path === 'auth' && (!!nav.prefillLogin || nav.addAccount === true)) {
    return of(true);
  }

  return inject(AuthService)
    .isValidToken()
    .pipe(
      map((isTokenValid: boolean) => {
        // console.log(route.routeConfig?.path);
        const guardCheck = (isTokenValid && route.routeConfig?.path === '') || (!isTokenValid && route.routeConfig?.path === 'auth');
        // console.log(guardCheck, route.routeConfig?.path);
        if (!guardCheck) {
          router.navigate([route.routeConfig?.path === '' ? 'auth' : '']);
        }
        return guardCheck;
      }),
    );
};
